// extracted by mini-css-extract-plugin
export default {"form":"SimpleExpressionForm_form__Z81R6","not-toggle":"SimpleExpressionForm_not-toggle__SGlmm"};